import { useEffect, useState } from "react";

const useGoogleMapsScript = (apiKey, language) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("useGoogleMapsScript: Loading script with language:", language); // Debug

    // Check if Google Maps is already loaded with the correct language
    if (window.google && window.google.maps) {
      console.log("useGoogleMapsScript: Google Maps already loaded");
      setIsLoaded(true);
      return;
    }

    // Remove any existing Google Maps script
    const existingScript = document.querySelector(
      `script[src*="maps.googleapis.com/maps/api/js"]`
    );
    if (existingScript) {
      console.log("useGoogleMapsScript: Removing existing script");
      existingScript.remove();
    }

    // Create new script element
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=${language}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      console.log("Google Maps script loaded successfully.");
      setIsLoaded(true);
    };
    script.onerror = () => {
      console.error("Failed to load Google Maps script.");
      setError("Failed to load Google Maps script.");
    };

    console.log("useGoogleMapsScript: Appending script with src:", script.src);
    document.head.appendChild(script);

    // Cleanup on unmount or language change
    return () => {
      if (document.head.contains(script)) {
        console.log("useGoogleMapsScript: Cleaning up script");
        document.head.removeChild(script);
      }
    };
  }, [apiKey, language]); // Re-run when language or apiKey changes

  return { isLoaded, error };
};

export default useGoogleMapsScript;
